import { Typography, Divider, Stack } from '@mui/material';

export default function TermsOfUseDe() {
  return (
    <Stack spacing={3}>
      <Typography variant="h4" fontWeight={700}>
        BRITESTAGE – Allgemeine Nutzungsbedingungen
      </Typography>
      <Typography variant="body2" color="text.secondary">
        <strong>Version 1.0</strong>
        <br />
        Letzte Aktualisierung: 13. April 2026
      </Typography>

      <Typography variant="body1">
        Diese Allgemeinen Nutzungsbedingungen (&bdquo;Bedingungen&ldquo;) regeln das Vertragsverhältnis zwischen:
      </Typography>
      <Typography variant="body1">
        <strong>21Minds GmbH</strong>
        <br />
        Botnanger Str. 6
        <br />
        70193 Stuttgart
        <br />
        Deutschland
        <br />
        (&bdquo;BRITESTAGE&ldquo;, &bdquo;wir&ldquo;, &bdquo;uns&ldquo;)
      </Typography>
      <Typography variant="body1">und</Typography>
      <Typography variant="body1">
        jeder natürlichen Person, die in gewerblicher oder geschäftlicher Eigenschaft handelt (&bdquo;Nutzer&ldquo;,
        &bdquo;Sie&ldquo;).
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        1. Geltungsbereich und Art der Plattform
      </Typography>
      <Typography variant="body1">
        1.1 BRITESTAGE ist eine professionelle Event-Infrastruktur- und Kollaborationsplattform, die die Planung,
        Verwaltung, Präsentation und Promotion von Veranstaltungen und zugehörigen Inhalten ermöglicht.
      </Typography>
      <Typography variant="body1">
        1.2 Die Plattform kann Profile, Kollaborationstools, Mitwirkendenverwaltung, Marktplatzfunktionen, KI-gestützte
        Tools und kostenpflichtige Dienste umfassen.
      </Typography>
      <Typography variant="body1">
        1.3 Die Plattform richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB und vergleichbarer
        internationaler Vorschriften.
      </Typography>
      <Typography variant="body1">
        1.4 Sofern ein Nutzer nach geltendem Recht als Verbraucher einzustufen ist, gelten zusätzlich zu diesen
        Bedingungen die zwingenden verbraucherschutzrechtlichen Vorschriften.
      </Typography>
      <Typography variant="body1">1.5 Ergänzend können gesonderte Organisationsbedingungen gelten.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        2. Berechtigung und Kontoregistrierung
      </Typography>
      <Typography variant="body1">2.1 Nur geschäftsfähige Personen dürfen sich registrieren.</Typography>
      <Typography variant="body1">2.2 Nutzer müssen korrekte, vollständige und aktuelle Angaben machen.</Typography>
      <Typography variant="body1">2.3 Konten sind persönlich und nicht übertragbar.</Typography>
      <Typography variant="body1">
        2.4 Nutzer sind für die Sicherung ihrer Zugangsdaten und sämtliche Aktivitäten unter ihrem Konto verantwortlich.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        3. Nutzerzentriertes Kontomodell
      </Typography>
      <Typography variant="body1">3.1 Nutzer unterhalten unabhängige Konten.</Typography>
      <Typography variant="body1">
        3.2 Nutzer können mit mehreren Organisationen und Veranstaltungen interagieren.
      </Typography>
      <Typography variant="body1">
        3.3 Die Löschung von Konten führt nicht automatisch zur Entfernung von in Veranstaltungen integrierten
        Beiträgen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        4. Nutzung im Auftrag von Organisationen
      </Typography>
      <Typography variant="body1">
        4.1 Nutzer können innerhalb der Plattform im Auftrag von Organisationen handeln.
      </Typography>
      <Typography variant="body1">
        4.2 In solchen Fällen handeln Nutzer als bevollmächtigte Vertreter der jeweiligen Organisation.
      </Typography>
      <Typography variant="body1">4.3 Die Organisation ist allein verantwortlich für:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die Festlegung von Zugriffsrechten und Berechtigungen;</li>
          <li>die Sicherstellung einer rechtmäßigen Verarbeitung personenbezogener Daten;</li>
          <li>die Einhaltung geltender gesetzlicher Pflichten.</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        4.4 Das Verhältnis zwischen BRITESTAGE und der Organisation kann durch gesonderte Organisationsbedingungen und,
        soweit anwendbar, durch einen Auftragsverarbeitungsvertrag (AVV) geregelt werden.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        5. Profilsichtbarkeit
      </Typography>
      <Typography variant="body1">5.1 Die Sichtbarkeit ist konfigurierbar und Opt-in.</Typography>
      <Typography variant="body1">
        5.2 Nutzer sind allein für alle veröffentlichten Informationen verantwortlich.
      </Typography>
      <Typography variant="body1">5.3 BRITESTAGE überprüft die Richtigkeit von Profildaten nicht.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        6. Bewertungen und Rankings
      </Typography>
      <Typography variant="body1">
        6.1 Bewertungen spiegeln die Meinungen der Nutzer wider und werden von BRITESTAGE nicht bestätigt.
      </Typography>
      <Typography variant="body1">6.2 BRITESTAGE überprüft Bewertungen nicht auf ihre Richtigkeit.</Typography>
      <Typography variant="body1">
        6.3 Es wird keine Garantie für Ranking-Logik, Sichtbarkeit oder Fairness übernommen.
      </Typography>
      <Typography variant="body1">6.4 Die Manipulation von Bewertungen oder Rankings ist verboten.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        7. Marktplatz und Verträge mit Dritten
      </Typography>
      <Typography variant="body1">
        7.1 BRITESTAGE stellt ausschließlich eine technische Infrastruktur bereit.
      </Typography>
      <Typography variant="body1">
        7.2 Verträge werden ausschließlich zwischen Nutzern und Dritten geschlossen.
      </Typography>
      <Typography variant="body1">
        7.3 BRITESTAGE ist weder Vertreter, Vermittler, Makler, Arbeitgeber noch Bevollmächtigter.
      </Typography>
      <Typography variant="body1">
        7.4 BRITESTAGE überprüft weder die Identität, Qualifikation, Rechtmäßigkeit noch die Zuverlässigkeit von Nutzern
        oder Organisationen.
      </Typography>
      <Typography variant="body1">
        7.5 BRITESTAGE übernimmt keine Garantie für Leistung, Ausführung oder Ergebnisse von Drittanbieterleistungen.
      </Typography>
      <Typography variant="body1">7.6 BRITESTAGE ist nicht an Streitigkeiten zwischen Nutzern beteiligt.</Typography>
      <Typography variant="body1">7.7 Die Zahlungsabwicklung kann durch Dritte erfolgen.</Typography>
      <Typography variant="body1">
        7.8 Nutzer sind allein für steuerliche, rechtliche und regulatorische Verpflichtungen verantwortlich.
      </Typography>
      <Typography variant="body1">
        7.9 Nutzer erkennen an, dass jeder Austausch personenbezogener Daten zwischen Nutzern und Organisationen im
        Rahmen von Marktplatz-Interaktionen in eigener Verantwortung als eigenständige Verantwortliche erfolgt.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        8. Kostenpflichtige Funktionen und Abonnements
      </Typography>
      <Typography variant="body1">8.1 Bestimmte Funktionen erfordern eine Zahlung.</Typography>
      <Typography variant="body1">
        8.2 Abonnements verlängern sich automatisch, sofern sie nicht gekündigt werden.
      </Typography>
      <Typography variant="body1">
        8.3 Im gesetzlich maximal zulässigen Umfang sind Zahlungen nicht erstattungsfähig.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        9. KI-gestützte Funktionen
      </Typography>
      <Typography variant="body1">9.1 KI-Funktionen sind lediglich unterstützende Werkzeuge.</Typography>
      <Typography variant="body1">
        9.2 Es wird keine Garantie für Richtigkeit, Vollständigkeit, Zuverlässigkeit oder Eignung übernommen.
      </Typography>
      <Typography variant="body1">9.3 KI-Ausgaben können unvollständig, verzerrt oder fehlerhaft sein.</Typography>
      <Typography variant="body1">9.4 Nutzer bleiben für alle Entscheidungen vollständig verantwortlich.</Typography>
      <Typography variant="body1">9.5 KI-Ausgaben stellen keine Rechts-, Finanz- oder Fachberatung dar.</Typography>
      <Typography variant="body1">9.6 BRITESTAGE haftet nicht für KI-generierte Ausgaben.</Typography>
      <Typography variant="body1">
        9.7 Soweit KI-gestützte Funktionen die Verarbeitung personenbezogener Daten umfassen, erfolgt diese Verarbeitung
        gemäß der Datenschutzerklärung und, soweit anwendbar, unter der Verantwortung der jeweiligen Organisation als
        Verantwortlicher.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        10. Zulässige Nutzung
      </Typography>
      <Typography variant="body1">Nutzer dürfen nicht:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Gegen geltendes Recht verstoßen</li>
          <li>Rechte Dritter verletzen</li>
          <li>Rechtswidrige oder schädliche Inhalte hochladen</li>
          <li>Systeme oder Rankings manipulieren</li>
          <li>Gebühren oder Provisionen umgehen</li>
          <li>Ohne Genehmigung auf Systeme zugreifen</li>
          <li>Die Plattformsicherheit beeinträchtigen</li>
        </ul>
      </Typography>
      <Typography variant="body1">BRITESTAGE kann Konten bei Verstößen sperren oder einschränken.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        11. Einhaltung des Gesetzes über digitale Dienste
      </Typography>
      <Typography variant="body1">11.1 Meldemechanismen für rechtswidrige Inhalte werden bereitgestellt.</Typography>
      <Typography variant="body1">
        11.2 BRITESTAGE hat keine allgemeine Pflicht zur Überwachung von Inhalten.
      </Typography>
      <Typography variant="body1">11.3 Inhalte können in gutem Glauben entfernt oder eingeschränkt werden.</Typography>
      <Typography variant="body1">11.4 Wiederholte Verstöße können zur Sperrung führen.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        12. Datenschutz und Rollen
      </Typography>
      <Typography variant="body1">
        12.1 BRITESTAGE verarbeitet personenbezogene Daten in Übereinstimmung mit den geltenden Datenschutzgesetzen,
        insbesondere der Datenschutz-Grundverordnung (DSGVO).
      </Typography>
      <Typography variant="body1">
        12.2 BRITESTAGE handelt als eigenständiger Verantwortlicher, soweit Nutzer:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>persönliche Profile erstellen und verwalten;</li>
          <li>Marktplatzfunktionen nutzen;</li>
          <li>mit Bewertungen, Rankings und öffentlich sichtbaren Funktionen interagieren.</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        12.3 Soweit Nutzer im Auftrag einer Organisation handeln und personenbezogene Daten innerhalb von
        Veranstaltungen, Sessions oder Organisationsstrukturen verarbeiten, handelt BRITESTAGE als Auftragsverarbeiter
        im Auftrag der jeweiligen Organisation.
      </Typography>
      <Typography variant="body1">
        12.4 In solchen Fällen bildet ein Auftragsverarbeitungsvertrag (AVV) einen integralen Bestandteil des
        Vertragsverhältnisses zwischen BRITESTAGE und der jeweiligen Organisation.
      </Typography>
      <Typography variant="body1">
        12.5 Umfang, Zweck und Rechtsgrundlage der Datenverarbeitung werden in der Datenschutzerklärung und, soweit
        anwendbar, im AVV näher bestimmt.
      </Typography>
      <Typography variant="body1">
        12.6 Nutzer gewährleisten, dass sie berechtigt sind, personenbezogene Daten innerhalb der Plattform zu
        verarbeiten und, soweit anwendbar, alle erforderlichen Einwilligungen oder Rechtsgrundlagen eingeholt haben.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        13. Geistiges Eigentum
      </Typography>
      <Typography variant="body1">13.1 Nutzer behalten das Eigentum an ihren Inhalten.</Typography>
      <Typography variant="body1">
        13.2 Nutzer gewähren BRITESTAGE eine weltweite, nicht-exklusive, gebührenfreie, übertragbare und
        unterlizenzierbare Lizenz zur Nutzung von Inhalten, streng beschränkt auf das für Folgendes erforderliche Maß:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Betrieb und Bereitstellung der Plattform;</li>
          <li>technische Verarbeitung, Speicherung und Übermittlung;</li>
          <li>Anzeige und Verbreitung innerhalb der Plattform;</li>
          <li>Sicherheit, Fehlerbehebung und Systemverbesserung;</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        13.3 Diese Nutzung ist auf das beschränkt, was für die Vertragserfüllung und die berechtigten Interessen von
        BRITESTAGE am Betrieb und der Verbesserung der Plattform erforderlich ist.
      </Typography>
      <Typography variant="body1">
        13.4 BRITESTAGE darf anonymisierte oder aggregierte Daten für Analysen, Serviceverbesserung und
        Produktentwicklung verwenden, sofern diese Daten keiner identifizierten oder identifizierbaren Person zugeordnet
        werden können.
      </Typography>
      <Typography variant="body1">
        13.5 Veranstalter können die erforderlichen Rechte zur Nutzung von Beiträgen im Veranstaltungskontext erhalten.
      </Typography>
      <Typography variant="body1">13.6 Nutzer gewährleisten, dass sie alle erforderlichen Rechte besitzen.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        14. Drittanbieterdienste
      </Typography>
      <Typography variant="body1">14.1 BRITESTAGE nutzt Drittanbieter.</Typography>
      <Typography variant="body1">
        14.2 BRITESTAGE ist nicht für deren Verfügbarkeit, Leistung oder Compliance verantwortlich.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        15. Datenspeicherung und Löschung
      </Typography>
      <Typography variant="body1">15.1 Konten können jederzeit gelöscht werden.</Typography>
      <Typography variant="body1">
        15.2 Daten werden gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
      </Typography>
      <Typography variant="body1">
        15.3 Beiträge können in anonymisierter oder eingebetteter Form im Veranstaltungskontext bestehen bleiben.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        16. Sperrung und Kündigung
      </Typography>
      <Typography variant="body1">16.1 Konten können bei Verstößen gesperrt oder gekündigt werden.</Typography>
      <Typography variant="body1">16.2 Eine sofortige Sperrung ist zulässig, soweit erforderlich.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        17. Dienstverfügbarkeit und Datenintegrität
      </Typography>
      <Typography variant="body1">
        17.1 BRITESTAGE betreibt die Plattform mit wirtschaftlich angemessener Sorgfalt und technischer
        Gewissenhaftigkeit. Eine ununterbrochene, rechtzeitige, sichere oder fehlerfreie Verfügbarkeit der Plattform
        wird jedoch nicht garantiert.
      </Typography>
      <Typography variant="body1">17.2 Insbesondere garantiert BRITESTAGE nicht, dass:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die Plattform jederzeit oder ohne Unterbrechung verfügbar ist;</li>
          <li>der Zugang frei von Verzögerungen, Ausfällen oder technischen Störungen ist;</li>
          <li>die Plattform ohne Fehler oder Mängel funktioniert;</li>
          <li>Daten ohne Verlust oder Beschädigung gespeichert oder übertragen werden.</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        17.3 Vorübergehende Einschränkungen oder Unterbrechungen können insbesondere auftreten durch:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Wartung, Updates oder technische Verbesserungen;</li>
          <li>Kapazitätsbeschränkungen oder Lastspitzen;</li>
          <li>Ausfälle von Drittsystemen oder Infrastruktur;</li>
          <li>Ereignisse außerhalb der Kontrolle von BRITESTAGE (einschließlich höherer Gewalt).</li>
        </ul>
      </Typography>
      <Typography variant="body1">
        17.4 BRITESTAGE wird wirtschaftlich angemessene Anstrengungen unternehmen, um Störungen zu minimieren und die
        Verfügbarkeit schnellstmöglich wiederherzustellen.
      </Typography>
      <Typography variant="body1">
        17.5 Nutzer sind allein dafür verantwortlich, ihre Daten und Inhalte in angemessenen Abständen eigenständig zu
        sichern.
      </Typography>
      <Typography variant="body1">
        17.6 Es werden keine Garantien für bestimmte Service-Level, Verfügbarkeitsquoten oder Wiederherstellungszeiten
        gegeben, sofern nicht ausdrücklich in einem gesonderten schriftlichen Service-Level-Agreement (SLA) vereinbart.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        18. Höhere Gewalt
      </Typography>
      <Typography variant="body1">
        BRITESTAGE haftet nicht für Ereignisse, die außerhalb seiner zumutbaren Kontrolle liegen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        19. Haftungsbeschränkung
      </Typography>
      <Typography variant="body1">
        19.1 Unbeschränkte Haftung besteht bei Vorsatz, grober Fahrlässigkeit, Verletzung von Leben, Körper oder
        Gesundheit sowie zwingender gesetzlicher Haftung.
      </Typography>
      <Typography variant="body1">
        19.2 Bei einfacher Fahrlässigkeit ist die Haftung auf die Verletzung wesentlicher Vertragspflichten
        (Kardinalpflichten) beschränkt.
      </Typography>
      <Typography variant="body1">
        19.3 In diesen Fällen ist die Haftung auf vorhersehbare, vertragstypische Schäden beschränkt.
      </Typography>
      <Typography variant="body1">
        19.4 Die Haftung für mittelbare Schäden, entgangenen Gewinn, Datenverlust, Marktplatz-Interaktionen,
        Drittanbieterdienste und KI-Ausgaben ist im gesetzlich zulässigen Umfang ausgeschlossen.
      </Typography>
      <Typography variant="body1">
        19.5 Die Gesamthaftung ist auf den höheren der folgenden Beträge beschränkt:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>die in den letzten 12 Monaten gezahlten Gebühren, oder</li>
          <li>EUR 10.000</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        20. Freistellung
      </Typography>
      <Typography variant="body1">Nutzer stellen BRITESTAGE von Ansprüchen Dritter frei, die entstehen aus:</Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>rechtswidrigen Inhalten</li>
          <li>Verletzungen geistigen Eigentums</li>
          <li>Missbrauch der Plattform</li>
          <li>Verstößen gegen diese Bedingungen</li>
        </ul>
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        21. Exportkontrolle und Sanktionen
      </Typography>
      <Typography variant="body1">
        Nutzer müssen alle geltenden Exportkontroll- und Sanktionsgesetze einhalten und dürfen die Plattform nicht in
        beschränkten Rechtsgebieten oder für verbotene Zwecke nutzen.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        22. Änderungen
      </Typography>
      <Typography variant="body1">
        22.1 BRITESTAGE kann diese Bedingungen mit angemessener Vorankündigung ändern.
      </Typography>
      <Typography variant="body1">22.2 Die fortgesetzte Nutzung gilt als Zustimmung.</Typography>
      <Typography variant="body1">22.3 Nutzer können vor Inkrafttreten der Änderungen kündigen.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        23. Anwendbares Recht und Gerichtsstand
      </Typography>
      <Typography variant="body1">23.1 Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts (CISG).</Typography>
      <Typography variant="body1">
        23.2 Ausschließlicher Gerichtsstand ist Stuttgart, Deutschland, soweit gesetzlich zulässig.
      </Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        24. Sprache
      </Typography>
      <Typography variant="body1">Die englische Fassung hat Vorrang.</Typography>

      <Divider />

      <Typography variant="h5" fontWeight={600}>
        25. Schlussbestimmungen
      </Typography>
      <Typography variant="body1">
        25.1 Sollte eine Bestimmung unwirksam sein, bleiben die übrigen Bestimmungen hiervon unberührt.
      </Typography>
      <Typography variant="body1">25.2 Ein Verzicht auf Rechte gilt nur bei ausdrücklicher Erklärung.</Typography>
    </Stack>
  );
}
